module.exports = __webpack_public_path__ + "static/media/floor_s.7a64d604.png";